module.exports = __webpack_public_path__ + "static/img/7.283303f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/7.png
// module id = thWW
// module chunks = 1